import { apiFetch } from "../../../lib/api/client";
import {
  questionnaireMemberStatusPageSchema,
  submissionDetailSchema,
  submissionPageSchema,
  summarySchema,
} from "../schemas/questionnaireSchemas";

function versionQuery(versionId?: string) {
  return versionId ? `?versionId=${encodeURIComponent(versionId)}` : "";
}

export async function getSummary(versionId?: string) {
  return summarySchema.parse(
    await apiFetch<unknown>(`/questionnaire/results/summary${versionQuery(versionId)}`),
  );
}

export async function listQuestionnaireSubmissions(versionId?: string) {
  return submissionPageSchema.parse(
    await apiFetch<unknown>(`/questionnaire/results/submissions${versionQuery(versionId)}`),
  );
}

export async function getQuestionnaireSubmission(id: string) {
  return submissionDetailSchema.parse(
    await apiFetch<unknown>(`/questionnaire/submissions/${id}`),
  );
}

export async function listQuestionnaireMemberStatuses(versionId?: string) {
  const suffix = versionQuery(versionId);
  const path = suffix ? `/questionnaire/results/members${suffix}&limit=100` : "/questionnaire/results/members?limit=100";
  return questionnaireMemberStatusPageSchema.parse(
    await apiFetch<unknown>(path),
  );
}
